import { CalendarRemoveOutlineIcon } from './CalendarRemoveOutlineIcon';

/**
 * author: Google
 * id 10475FB2-142C-48FF-AB95-B93CF2680208
 * name calendar-remove-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-remove-outline.svg
 * tags
 * - Date / Time 
 */
export const EventRemoveOutlineIcon = CalendarRemoveOutlineIcon;
export default EventRemoveOutlineIcon